import React from 'react';
import PropTypes from 'prop-types';

import PromotionUnlockedChip from 'bento-ordering/promotions/components/PromotionUnlockedChip';
import MenuItemDescriptionTypography from 'components/MenuItemDescriptionTypography';
import { HEADER } from 'styles/constants/appearanceSectionNames';

const PromotionProgress = ({ unlocked, promotionProgressMessage }) => {
  if (unlocked) {
    return <PromotionUnlockedChip />;
  }
  return (
    <MenuItemDescriptionTypography variant={HEADER}>
      {promotionProgressMessage}
    </MenuItemDescriptionTypography>
  );
};

PromotionProgress.propTypes = {
  promotionProgressMessage: PropTypes.string.isRequired,
  unlocked: PropTypes.bool.isRequired
};

export default PromotionProgress;
